import React, { useContext } from "react";

// context
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

// components
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import AddCommunity from "./AddCommunity";

const AddCommunityPop = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({ type: "POP_UP_OPEN", id: "ADD_COMUNITY_POP", open: { addComunityPop: false } });
  };

  return (
    <CustomDialog open={state.addComunityPop} onClose={handleClose}>
      <AddCommunity handleClose={handleClose} />
    </CustomDialog>
  );
};

export default AddCommunityPop;
